import { DataPolicyStatus, SupportedLanguage, SupportedMarket } from '@estercare/ester-shared'

export enum Gender {
  M = 'M',
  F = 'F',
  U = 'U',
}

export type User = {
  id: string
  email: string
  firstName: string
  lastName: string
  organisationId: string
  organisationName?: string
  createdAt?: string
  permissions: string[]
  lastLogin: string | null
  birthYear: number | null
  gender: Gender | null
  zipCode: number | null
  isManager: boolean
  personalNumber: string | null
  language: SupportedLanguage | null
  market: SupportedMarket
  department: string | null
  inviterName: string | null
  hasInvitedUser?: boolean
  dataPolicy?: DataPolicyStatus
}

export type UsersFromOrganisationDb = Omit<User, 'permissions'> & {
  id: string
  UserPermission: {
    permission: Permission
  }[]
}

export type CreatedUser = {
  email: string
  firstName: string
  lastName: string
}

export type CreateUsersResponse = {
  createdUsers: CreatedUser[]
  alreadyExistingUsers: CreatedUser[]
}

export type Permission = 'EMPLOYEE' | 'ADMIN' | 'ATHLETE'

export type InviteUserRequest = {
  firstName: string
  lastName: string
  email: string
}

export type InviteUserResponse = {
  id: string
  email: string
  firstName: string
  lastName: string
}
